import { Field, FieldProps, useFormikContext } from 'formik';
import React, { useRef } from 'react';
import { Button, Form, FormControl, InputGroup } from 'react-bootstrap';
import { ErrorI18n } from '../error';

export type FileProps = {
  controlId: string;
  accept?: string;
  label?: string;
  className?: string;
  placeholder?: string;
};

export const File = ({ controlId, accept, label, placeholder, className = '' }: FileProps) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const inputRef = useRef<HTMLInputElement>(null);

  function handleOnClick() {
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.click();
    }
  }

  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget?.files && event.currentTarget.files.length > 0) {
      setFieldTouched(controlId, true);
      setFieldValue(controlId, event.currentTarget.files[0], true);
    }
  }

  return (
    <div className={`file${className ? ` ${className}` : ''}`}>
      <Field name={controlId}>
        {({ field, meta }: FieldProps<File, File>) => (
          <>
            <Form.Group controlId={controlId} className="form-group">
              {label && <Form.Label>{label}</Form.Label>}
              <InputGroup>
                <FormControl
                  type="text"
                  readOnly
                  placeholder={field.value ? field.value.name : placeholder}
                  onClick={handleOnClick}
                  isValid={!meta.error && meta.touched}
                  isInvalid={!!meta.error && meta.touched}
                  aria-describedby="inputGroupAppend"
                />
                <Button type="button" onClick={handleOnClick}>
                  Browse final terms file
                </Button>
              </InputGroup>
              {!!meta.error && meta.touched && <ErrorI18n {...meta} />}
            </Form.Group>
            <input
              type="file"
              hidden
              ref={inputRef}
              accept={accept}
              onChange={(event) => handleFileChange(event as React.ChangeEvent<HTMLInputElement>)}
            />
          </>
        )}
      </Field>
    </div>
  );
};
